import { Container } from '@mui/material';
import React, { useContext } from 'react';
import { ThemeContext } from '../../../contexts/theme-context';
import { infrastructureData } from '../../../data/infrastructureData';
import './infrastructure.css';

function Infrastructure() {
  const { theme } = useContext(ThemeContext);

  return (
    <div style={{ backgroundColor: theme.secondary }}>
      <Container className='infrastructure' id='infrastructure'>
        <h1 style={{ color: theme.primary }}>{infrastructureData.title}</h1>
        <h2 style={{ color: theme.tertiary }}>{infrastructureData.subtitle}</h2>
        <p style={{ color: theme.tertiary }} className='infra-overview'>
          {infrastructureData.overview}
        </p>

        <div className='infra-grid'>
          <section className='infra-card' style={{ background: theme.quaternary }}>
            <h3 style={{ color: theme.primary }}>Running Services</h3>
            <ul>
              {infrastructureData.services.map((service) => (
                <li key={service} style={{ color: theme.tertiary }}>
                  {service}
                </li>
              ))}
            </ul>
          </section>

          <section className='infra-card' style={{ background: theme.quaternary }}>
            <h3 style={{ color: theme.primary }}>Infrastructure Capabilities</h3>
            <ul>
              {infrastructureData.competencies.map((item) => (
                <li key={item} style={{ color: theme.tertiary }}>
                  {item}
                </li>
              ))}
            </ul>
          </section>
        </div>
      </Container>
    </div>
  );
}

export default Infrastructure;
